import { all, put, takeLatest } from 'redux-saga/effects';
import {
  CREATE_CONNECT_ACCOUNT,
  GENERATE_CONNECT_LINK,
  GET_BALANCE,
  GET_EXPRESS_LINK,
  REDEEM_BALANCE,
  REFUND_BALANCE,
  SEND_INVOICE,
} from './constants';
import Api from '../../commons/api';
import { APP_ROUTES } from '../../constants/app-routes';
import * as BalanceActions from './action';
import * as UserActions from '../users/action';

const controller = 'balance';

function constructConnectAccountBody(payload) {
  const { userId } = payload;
  const { origin } = window.location;
  const body = {
    userId,
    returnUrl: `${origin}${APP_ROUTES.STRIPE_REDIRECT}?route=${APP_ROUTES.VENDOR_PROFILE}`,
    refreshUrl: `${origin}${APP_ROUTES.STRIPE_REDIRECT}?route=${APP_ROUTES.DASHBOARD}`,
  };
  return body;
}

function* getBalance({ payload }) {
  try {
    const { userId } = payload;
    const { data } = yield Api.get(`${controller}/${controller}/${userId}`);
    yield put(BalanceActions.getBalanceSuccess(data));
  } catch (err) {
    yield put(BalanceActions.getBalanceFailed(err));
  }
}

function* redeemBalance({ payload }) {
  try {
    const { data } = yield Api.post(`${controller}/${controller}/redeem`, payload);
    const redeemedAmount = data.amount / 100.0;
    yield put(BalanceActions.redeemBalanceSuccess(redeemedAmount));
  } catch (err) {
    yield put(BalanceActions.redeemBalanceFailed(err));
  }
}

function* refundBalance({ payload }) {
  try {
    const { venueId, ...refundRequest } = payload;
    yield Api.post(`${controller}/${controller}/refund`, refundRequest);

    yield put(BalanceActions.refundBalanceSuccess());
    yield put(UserActions.getVendorsByVenue(venueId));
  } catch (err) {
    yield put(BalanceActions.refundBalanceFailed(err));
  }
}

function* createConnectAccount({ payload }) {
  try {
    const body = constructConnectAccountBody(payload);
    const { data } = yield Api.post(`${controller}/${controller}/create-connect-account`, body);
    window.location = data.url;
    yield put(BalanceActions.createConnectAccountSuccess());
  } catch (err) {
    yield put(BalanceActions.createConnectAccountFailed(err));
  }
}

function* generateConnectAccountLink({ payload }) {
  try {
    const body = constructConnectAccountBody(payload);
    const { data } = yield Api.post(`${controller}/${controller}/generate-account-link`, body);
    window.location = data.url;
    yield put(BalanceActions.generateConnectAccountLinkSuccess());
  } catch (err) {
    yield put(BalanceActions.createConnectAccountFailed(err));
  }
}

function* getExpressLink({ payload }) {
  try {
    const { userId, isAdmin } = payload;
    let link;
    if (!isAdmin) {
      const { data } = yield Api.get(`${controller}/${controller}/${userId}/express-link`);
      link = data.url;
    }
    yield put(BalanceActions.getExpressLinkSuccess(link));
  } catch (err) {
    yield put(BalanceActions.getExpressLinkFailed(err));
  }
}

function* sendInvoice({ payload }) {
  try {
    const { eventId, vendorId } = payload;
    const { data } = yield Api.post(`${controller}/${controller}/invoice/`, { eventId, vendorId });
    yield put(BalanceActions.sendInvoiceSuccess(data));
  } catch (err) {
    yield put(BalanceActions.sendInvoiceFailed(err));
  }
}

function* ActionWatcher() {
  yield takeLatest(GET_BALANCE, getBalance);
  yield takeLatest(CREATE_CONNECT_ACCOUNT, createConnectAccount);
  yield takeLatest(GENERATE_CONNECT_LINK, generateConnectAccountLink);
  yield takeLatest(REDEEM_BALANCE, redeemBalance);
  yield takeLatest(GET_EXPRESS_LINK, getExpressLink);
  yield takeLatest(REFUND_BALANCE, refundBalance);
  yield takeLatest(SEND_INVOICE, sendInvoice);
}

export default function* BalanceSaga() {
  yield all([ActionWatcher()]);
}
